import { Expose, plainToClassFromExist } from 'class-transformer';
import { isObject } from 'lodash';

export class SnHttpResponseFilter {
  @Expose()
  public name: string;

  @Expose()
  public field: string;

  @Expose()
  public data: string[];

  constructor(data: any) {
    if (data && isObject(data)) {
      plainToClassFromExist(this, data, { excludeExtraneousValues: true });
    }
  }
}
